import { Fragment } from 'react';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import UIImage from 'UIComponents/image/UIImage';
import { ColumnTypes } from 'ContentUtils/constants/HubDbColumnTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const nonBreakingSpaceChar = '\xa0';
const nonWhitespaceCharRegex = /\S/;
const whitespaceRegex = /\s/;
const whitespaceWithValueRegex = /(\s)/;
const lineBreakRegex = /\r?\n|\r/;
const formatTextContent = (index, labelContent) => {
  const whitespaceArray = labelContent.split(whitespaceWithValueRegex);
  const textContent = [];
  whitespaceArray.forEach(char => {
    if (lineBreakRegex.test(char)) {
      textContent.push( /*#__PURE__*/_jsx("br", {}, `br-${index}`));
    } else if (whitespaceRegex.test(char)) {
      textContent.push(nonBreakingSpaceChar);
    }
  });
  return /*#__PURE__*/_jsx(Fragment, {
    children: textContent
  }, index);
};

// If making edits consider if applicable to CRM Object field's `getCrmObjectLabel`.
export const formatRowLabel = labelContents => {
  if (!Array.isArray(labelContents)) return labelContents;
  return labelContents.reduce((acc, labelData, index) => {
    const contentType = labelData.columnType || '';
    const labelContent = labelData.text;
    if (typeof labelContent === 'string' && !nonWhitespaceCharRegex.test(labelContent)) {
      acc.push(formatTextContent(index, labelContent));
    } else if (contentType === ColumnTypes.SELECT) {
      const selectContentName = labelContent.name;
      acc.push( /*#__PURE__*/_jsx(Fragment, {
        children: selectContentName
      }, index));
    } else if (typeof labelContent === 'number' && contentType.includes(ColumnTypes.DATE)) {
      acc.push( /*#__PURE__*/_jsx(FormattedDateTime, {
        format: contentType === ColumnTypes.DATETIME ? 'lll' : 'll',
        value: labelContent
      }, index));
    } else if (contentType === ColumnTypes.IMAGE) {
      acc.push( /*#__PURE__*/_jsx(UIImage, {
        className: index === 0 ? 'm-right-1' : 'm-x-1',
        responsive: false,
        shape: "thumbnail",
        src: labelContent.url,
        style: {
          maxHeight: 24
        }
      }, index));
    } else {
      acc.push( /*#__PURE__*/_jsx(Fragment, {
        children: labelContent
      }, index));
    }
    return acc;
  }, []);
};